
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.569 15a1.594 1.594 0 01-1.1-.43 1.407 1.407 0 01-.082-1.989c.026-.029.054-.056.082-.082l4.759-4.492L4.455 3.5a1.407 1.407 0 01-.084-1.987q.04-.044.084-.084a1.618 1.618 0 012.194 0l5.876 5.536a1.409 1.409 0 01.075 1.99q-.037.04-.078.078l-5.853 5.526a1.613 1.613 0 01-1.089.43"}})])
          )
        }
      }
    